import {Nullish} from 'shared/web';

import {filterByMinMax} from './filterByMinMax';

const POWER_VALUES = [0, 40, 50, 60, 70, 80, 90, 100, 125, 150, 175, 200, 250, 300];

export const getPowerOptions = (min?: number | Nullish, max?: number | Nullish) =>
  filterByMinMax(min, max)(POWER_VALUES);
